module.exports = __webpack_public_path__ + "assets/logo_footer_old.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/logo_footer_old.jpg
 ** module id = 221
 ** module chunks = 1
 **/